<script>
	import { Router, Route } from "svelte-routing";
	import AccountManagement from "../AccountManagement/AccountManagement.svelte";
	import EvAccManagement from "../EvAccManagement/EvAccManagement.svelte";
	import FmsAccountManagement from "../FMSAccountManagement/FMSAccountManagement.svelte";
</script>

<Router url="/">
	<Route path="/account-management/*" component={AccountManagement} />
	<Route path="/ev-account-management/*" component={EvAccManagement} />
	<Route path="/fms-account-management/*" component={FmsAccountManagement} />
</Router>
